import {Observer} from "web-vcore";
import React from "react";
import {CheckBox, Column, Row, RowLR, Spinner, Text, TextInput} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {EngineConfigPanels_SharedProps, ExtendEngineConfigPanelSharedProps} from "../ConfigPanel_Local.js";
import {observer_mgl} from "mobx-graphlink";
import {SpinnerForPercent} from "../../../../Utils/ReactComponents/SpinnerForPercent.js";

const GetSharedProps = (props: EngineConfigPanels_SharedProps)=>ExtendEngineConfigPanelSharedProps(props, c=>c.journeyTraining, (c, v)=>c.journeyTraining = v);

const splitAt = 150;

export const JourneyTraining_ConfigUI = observer_mgl((props: {remote?: boolean} & EngineConfigPanels_SharedProps)=>{
	const {enabled} = props;
	const sharedProps = GetSharedProps(props);
	const {config, ChangeConfig} = sharedProps;

	return (
		<Column mt={15} style={{background: "hsla(0,0%,100%,.1)", borderRadius: 5, padding: 5}}>
			<Row style={{fontSize: 18}}>
				<CheckBox text="Journey -> Training Mode" enabled={enabled} value={config.enabled} onChange={val=>ChangeConfig(c=>c.enabled = val)}/>
			</Row>

			{config.enabled &&
			<>
				<RowLR mt={5} splitAt={splitAt}>
					<Text mr={5}>Voice, tag:</Text>
					<TextInput enabled={enabled} style={{width: 80}} value={config.voiceSoundTag} onChange={val=>ChangeConfig(c=>c.voiceSoundTag = val)}/>
					<Text ml={5} mr={5}>Vol. mult.:</Text>
					<SpinnerForPercent enabled={enabled} min={0} max={999} value={config.volumeMultiplier} onChange={val=>ChangeConfig(c=>c.volumeMultiplier = val)}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<Text>Entity tags:</Text>
					<TextInput enabled={enabled} style={{width: "100%"}}
						value={(config.entityTags || []).join(", ")} onChange={val=>ChangeConfig(c=>c.entityTags = val.split(",").map(a=>a.trim()).filter(a=>a))}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<Text>Entity min-count:</Text>
					<Spinner min={0} enabled={enabled} value={config.entityMinCount} onChange={val=>ChangeConfig(c=>c.entityMinCount = val)}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<Text>Seeds, base per entity:</Text>
					<Spinner min={0} enabled={enabled} value={config.seeds_basePerEntity} onChange={val=>ChangeConfig(c=>c.seeds_basePerEntity = val)}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<Text>Seeds, add from dreams:</Text>
					<CheckBox enabled={enabled} value={config.seeds_addFromDreams} onChange={val=>ChangeConfig(c=>c.seeds_addFromDreams = val)}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<Text>Prefix text:</Text>
					<TextInput enabled={enabled} value={config.prefixText} onChange={val=>ChangeConfig(c=>c.prefixText = val)}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<Text>Postfix text:</Text>
					<TextInput enabled={enabled} value={config.postfixText} onChange={val=>ChangeConfig(c=>c.postfixText = val)}/>
				</RowLR>
			</>}
		</Column>
	);
});